// MO4.1.3
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import UserIdentity from '../../User/Identity';
import TierPriceWithBadge from '../Helper/TierPriceWithBadge';
import TierStatisticsBar from '../Helper/StatisticsBar/TierStatisticsBar';
import DeviationDumbView from '../Dumbo';
import UnknownDumbo from '../Dumbo/Unknown';
import s from './VerticalTierPromotionCardDumb.scss';
const COVER_WIDTH_TO_HEIGHT_RATIO = 0.3987;
const VerticalTierPromotionCardDumb = ({ title, description, author, showAuthor = true, stats, isBoosted, price, coverImage, showMatureCover, ctaButton, width, height, style, showEmptyPlaceholders, state = 'active', className, ctaWrapperClassName, onClick, innerRef })=>{
    const { t } = useTranslation();
    if (!width) {
        return null;
    }
    const dumboWidth = width - (32 + 2);
    const dumboHeight = dumboWidth * COVER_WIDTH_TO_HEIGHT_RATIO;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className),
        style: _object_spread({
            width: width,
            maxHeight: height
        }, style),
        onClick: onClick,
        ref: innerRef
    }, showAuthor && author && /*#__PURE__*/ React.createElement(UserIdentity, {
        user: author,
        size: "small",
        className: s['identity']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['dumbo-wrapper']
    }, coverImage ? /*#__PURE__*/ React.createElement(DeviationDumbView, {
        className: s['dumbo'],
        deviation: coverImage,
        width: dumboWidth,
        height: dumboHeight,
        showMatureContent: showMatureCover
    }) : showEmptyPlaceholders ? /*#__PURE__*/ React.createElement("div", {
        className: s['cover-placeholder'],
        style: {
            width: dumboWidth,
            height: dumboHeight
        }
    }) : /*#__PURE__*/ React.createElement(UnknownDumbo, {
        className: s['dumbo'],
        width: dumboWidth,
        height: dumboHeight
    }), state !== 'active' && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['state-tag'], s[state])
    }, t(`deviationview.tierCard.state.${state}`))), title ? /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title) : showEmptyPlaceholders && /*#__PURE__*/ React.createElement("div", {
        className: s['title-placeholder']
    }), /*#__PURE__*/ React.createElement(TierStatisticsBar, {
        className: s['statistics'],
        stats: stats,
        isBoosted: isBoosted
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, description), /*#__PURE__*/ React.createElement("hr", {
        className: s['divider']
    }), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center",
        className: ctaWrapperClassName
    }, /*#__PURE__*/ React.createElement(TierPriceWithBadge, {
        className: s['price'],
        price: price,
        showPlaceholder: showEmptyPlaceholders
    }), ctaButton));
};
VerticalTierPromotionCardDumb.displayName = 'VerticalTierPromotionCardDumb';
export default VerticalTierPromotionCardDumb;

//# sourceMappingURL=VerticalTierPromotionCardDumb.js.map